/* Angler's Coffee "cast to cart", v2 (2026-10-07; v1 went live 2026-10-04)
   After a successful ajax add-to-cart, a fly rod casts to the product photo and swings the catch into the
   landing-net cart icon. Decoration only: the item is already in the cart before this starts, and the whole run
   (~1.4s) fits inside the theme's own 1.5s button animation, so the cart drawer is never delayed.
   v2:
   - Swing motion: back cast, pause, forward cast, the loop unrolls and the fly lands; then the rod lifts and the
     product swings in on the line (v1 shot the line straight at the product).
   - Product pages: header style "scroll" slides the header (and the net) away while you scroll down to Add to Cart,
     and v1 silently skipped the cast whenever the net was off screen. The header is now brought back first.
   - Hooks the part of the photo that is on screen (largest visible image near the form), never a hidden slide.
     If no photo is on screen (phones, far down the page), the product pops up above the Add to Cart button.
   - Plays on every add (a second add during a running cast just bounces the net). Reduced motion: net bounce only.
   - Every step is wrapped so a failure here can never affect the cart. */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  // Timeline (ms): back cast, pause, forward cast, loop unrolls onto the product, hook set, swing into the net.
  var T1 = 260, T2 = T1 + 70, T3 = T2 + 230, T4 = T3 + 300, T5 = T4 + 70, T6 = T5 + 470;
  var busy = false;

  function reduced() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function onScreen(r) { return r.width > 4 && r.height > 4 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth; }
  function netIcon() {
    var c = document.querySelectorAll('svg.icon-cart');
    for (var i = 0; i < c.length; i++) if (onScreen(c[i].getBoundingClientRect())) return c[i];
    return null;
  }
  // Header style "scroll" hides the header while scrolling down, which is how shoppers reach Add to Cart.
  function showHeader() {
    var b = document.body;
    if (b.classList.contains('header-up')) { b.classList.remove('header-up'); b.classList.add('header-down'); }
  }
  // The product photo the shopper can actually see: the largest on-screen image near the form.
  function productImage(form) {
    var scope = (form && (form.closest('.product-card') || form.closest('.shopify-section') || form.closest('section'))) || document;
    var imgs = scope.querySelectorAll('img'), best = null, bestArea = 0;
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i], r = im.getBoundingClientRect();
      if (r.width < 80 || !onScreen(r) || im.closest('[aria-hidden="true"]')) continue;
      var x0 = Math.max(r.left, 0), x1 = Math.min(r.right, innerWidth), y0 = Math.max(r.top, 0), y1 = Math.min(r.bottom, innerHeight);
      var area = (x1 - x0) * (y1 - y0), cs = getComputedStyle(im);
      if (area > bestArea && cs.visibility !== 'hidden' && +cs.opacity > 0.1) { bestArea = area; best = { img: im, rect: r, box: { x: x0, y: y0, w: x1 - x0, h: y1 - y0 } }; }
    }
    if (!best && form && form.querySelector) {
      // No photo on screen: the product pops up just above the Add to Cart button instead.
      var any = scope.querySelector('img'), btn = form.querySelector('[type="submit"], .js-product-add') || form, b = btn.getBoundingClientRect(), s = 120;
      if (any && onScreen(b)) best = { img: any, rect: null, popup: true, box: { x: Math.max(8, Math.min(innerWidth - s - 8, b.left + b.width / 2 - s / 2)), y: Math.max(8, b.top - s - 14), w: s, h: s } };
    }
    return best;
  }
  function bounce(net) {
    if (!net || !net.animate) return;
    net.animate([{ transform: 'translateY(0) scale(1)' }, { transform: 'translateY(4px) scale(1.15,.9)' }, { transform: 'translateY(-2px) scale(.96,1.05)' }, { transform: 'none' }], { duration: 420, easing: 'ease-out' });
  }

  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function seg(t, a, b) { return clamp01((t - a) / (b - a)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function inOut(t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function out(t) { return 1 - (1 - t) * (1 - t); }
  function polar(o, r, deg) { var a = deg * Math.PI / 180; return { x: o.x + r * Math.cos(a), y: o.y + r * Math.sin(a) }; }
  function qpt(p0, p1, p2, t) { return { x: (1 - t) * (1 - t) * p0.x + 2 * (1 - t) * t * p1.x + t * t * p2.x, y: (1 - t) * (1 - t) * p0.y + 2 * (1 - t) * t * p1.y + t * t * p2.y }; }
  function pts(a) { return a.map(function (p) { return p.x.toFixed(1) + ',' + p.y.toFixed(1); }).join(' '); }
  function svgEl(tag, attrs, parent) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (parent) parent.appendChild(e); return e; }

  // Builds the scene for one cast; draw(t) renders the frame at t ms, so the motion is a pure function of time.
  function make(pick) {
    var W = innerWidth, H = innerHeight, box = pick.box;
    var S0 = Math.max(60, Math.min(box.w, box.h, 260));               // size of the photo that lifts off
    var cx = box.x + box.w / 2, cy = box.y + box.h / 2;
    var A0 = { x: cx, y: cy - S0 / 2 };                                // top center of the lifted photo (where it hangs from)
    var G = { x: A0.x, y: A0.y + S0 * 0.08 };                          // where the fly lands
    var butt = { x: Math.max(30, W * 0.12), y: H - Math.max(60, H * 0.1) }, len = Math.min(W, H) * 0.48, Rb = len * 0.6;   // butt clear of bottom bars
    var fade = !pick.popup;
    var svg = svgEl('svg', { width: W, height: H, viewBox: '0 0 ' + W + ' ' + H, 'aria-hidden': 'true' });
    svg.style.cssText = 'position:fixed;left:0;top:0;width:' + W + 'px;height:' + H + 'px;pointer-events:none;z-index:2147483000;overflow:visible';
    var line = svgEl('path', { fill: 'none', stroke: '#f07a1a', 'stroke-width': 2.4, 'stroke-linecap': 'round' }, svg);
    var rodg = svgEl('g', {}, svg), rod = svgEl('polygon', { fill: '#4a2f1c' }, rodg), grip = svgEl('polygon', { fill: '#c9a36a', stroke: '#8a6a3a', 'stroke-width': 1 }, rodg);
    var reel = svgEl('circle', { r: 11, fill: '#b9bcc0', stroke: '#2a2a2a', 'stroke-width': 3 }, rodg), hub = svgEl('circle', { r: 4, fill: '#c8232c' }, rodg);
    var fly = svgEl('g', {}, svg);
    svgEl('path', { d: 'M0,0 L-10,-6 L-8,0 L-10,6 Z', fill: '#c8232c' }, fly);
    svgEl('path', { d: 'M-2,-2 Q4,-12 8,-14 M-2,2 Q4,12 8,14', stroke: '#e8c27a', 'stroke-width': 2, fill: 'none' }, fly);
    document.body.appendChild(svg);
    var clone = null, N = null, src = pick.img.currentSrc || pick.img.src;

    function angle(t) {                                                // rod angle in radians from horizontal
      if (t < T1) return lerp(1.05, 1.75, inOut(seg(t, 0, T1)));       // back cast
      if (t < T2) return lerp(1.75, 1.8, out(seg(t, T1, T2)));          // drift while the line straightens behind
      if (t < T3) return lerp(1.8, 0.8, inOut(seg(t, T2, T3)));          // forward cast, hard stop
      if (t < T4) { var p = seg(t, T3, T4); return 0.8 - 0.07 * Math.sin(Math.PI * Math.min(1, p * 2)) * (1 - p); } // rod rebounds
      if (t < T5) return lerp(0.8, 0.92, out(seg(t, T4, T5)));          // hook set
      return lerp(0.92, 1.5, inOut(seg(t, T5, T6)));                    // lift and swing the catch in
    }
    function rodAt(t) {
      var a = angle(t), v = (a - angle(t - 12)) / 12;
      var bend = Math.max(-0.14, Math.min(0.14, v * 16)) * len;       // the tip lags the swing, like a loaded rod
      var d = { x: Math.cos(a), y: -Math.sin(a) }, n = { x: Math.sin(a), y: Math.cos(a) };
      return function (s, w) { var o = bend * s * s + w; return { x: butt.x + d.x * len * s + n.x * o, y: butt.y + d.y * len * s + n.y * o }; };
    }
    function netCenter() {
      if (!N) { var net = netIcon(), r = net && net.getBoundingClientRect(); N = r ? { x: r.left + r.width / 2, y: r.top + r.height / 2 } : { x: W - 40, y: 28 }; }
      return N;
    }
    function ensureClone() {
      if (clone) return;
      clone = pick.img.cloneNode(); clone.removeAttribute('srcset'); clone.removeAttribute('sizes'); clone.removeAttribute('loading'); clone.src = src;
      clone.style.cssText = 'position:fixed;margin:0;padding:0;z-index:2147483001;pointer-events:none;object-fit:contain;max-width:none;transform-origin:50% 0;' +
        'background:#fff;border-radius:10px;box-shadow:0 10px 26px rgba(0,0,0,.22);' +
        'left:' + (cx - S0 / 2) + 'px;top:' + (cy - S0 / 2) + 'px;width:' + S0 + 'px;height:' + S0 + 'px';
      document.body.appendChild(clone);
      if (fade) pick.img.style.opacity = '.35';
    }
    function place(anchor, rot, sc) {
      clone.style.transform = 'translate(' + (anchor.x - A0.x).toFixed(1) + 'px,' + (anchor.y - A0.y).toFixed(1) + 'px) rotate(' + rot.toFixed(1) + 'deg) scale(' + sc.toFixed(3) + ')';
    }

    function draw(t) {
      var R = rodAt(t), L = [], Rr = [], i, p, E, C;
      for (i = 0; i <= 10; i++) { var s = i / 10, w = lerp(5.5, 0.9, s) / 2; L.push(R(s, w)); Rr.unshift(R(s, -w)); }
      rod.setAttribute('points', pts(L.concat(Rr)));
      grip.setAttribute('points', pts([R(.03, 3.25), R(.2, 2.5), R(.2, -2.5), R(.03, -3.25)]));
      var rc = R(.08, 13); reel.setAttribute('cx', rc.x); reel.setAttribute('cy', rc.y); hub.setAttribute('cx', rc.x); hub.setAttribute('cy', rc.y);
      var tip = R(1, 0);
      if (t < T1) {                                   // line lifts off in front, swings up and back over the rod
        p = seg(t, 0, T1); var phi = lerp(40, -150, inOut(p)), r = lerp(36, Rb, out(p));
        E = polar(tip, r, phi); C = polar(tip, r * 0.55, phi + 40 * Math.sin(Math.PI * p));
      } else if (t < T2) {                            // straightens out behind
        p = seg(t, T1, T2); var ph2 = lerp(-150, -162, out(p));
        E = polar(tip, Rb, ph2); C = polar(tip, Rb * 0.5, ph2 + 6 * (1 - p));
      } else if (t < T3) {                            // forward cast: the line swings over the top
        p = seg(t, T2, T3); var ph3 = lerp(-162, -40, inOut(p));
        E = polar(tip, Rb, ph3); C = polar(tip, Rb * 0.55, ph3 - 45 * Math.sin(Math.PI * p));
      } else if (t < T4) {                            // the loop unrolls and the fly drops onto the product
        p = out(seg(t, T3, T4)); var st = polar(tip, Rb, -40);
        E = qpt(st, { x: G.x, y: Math.min(st.y, G.y) - 40 }, G, p);
        C = { x: (tip.x + E.x) / 2, y: Math.min(tip.y, E.y) - 70 * (1 - p) };
      } else if (t < T5) {                            // hook set: the photo lifts off
        p = seg(t, T4, T5); ensureClone(); E = G; C = { x: (tip.x + G.x) / 2, y: (tip.y + G.y) / 2 + 12 * (1 - p) };
        place({ x: A0.x, y: A0.y - 10 * Math.sin(Math.PI * p) }, 6 * Math.sin(3 * Math.PI * p), pick.popup ? out(p) : 1 + 0.04 * Math.sin(Math.PI * p));
      } else {                                        // the rod lifts and the catch swings in on the line: dips, then rises into the net
        p = seg(t, T5, T6); ensureClone(); var n = netCenter(), e = inOut(p);
        var hk = qpt(G, { x: (G.x + n.x) / 2, y: Math.max(G.y, n.y) + H * 0.16 }, n, e);
        var sc = lerp(1, 0.08, Math.pow(p, 1.4));
        place({ x: hk.x, y: hk.y - S0 * 0.08 * sc }, 18 * Math.sin(2 * Math.PI * 1.2 * p) * (1 - p), sc);
        E = hk; C = { x: (tip.x + hk.x) / 2, y: (tip.y + hk.y) / 2 + 24 * (1 - p) };
      }
      line.setAttribute('d', 'M' + tip.x.toFixed(1) + ',' + tip.y.toFixed(1) + ' Q' + C.x.toFixed(1) + ',' + C.y.toFixed(1) + ' ' + E.x.toFixed(1) + ',' + E.y.toFixed(1));
      fly.setAttribute('transform', 'translate(' + E.x.toFixed(1) + ',' + E.y.toFixed(1) + ') rotate(' + (Math.atan2(E.y - C.y, E.x - C.x) * 180 / Math.PI).toFixed(0) + ')');
    }
    function destroy() {
      try { svg.remove(); } catch (e) {}
      try { if (clone) clone.remove(); } catch (e) {}
      try { pick.img.style.opacity = ''; } catch (e) {}
    }
    return { draw: draw, destroy: destroy, end: T6 };
  }

  function cast(form) {
    showHeader();
    var later = function () { setTimeout(function () { bounce(netIcon()); }, 350); };
    if (busy || reduced()) return later();
    var pick = productImage(form);
    if (!pick) return later();
    busy = true;
    var c = make(pick), start = performance.now(), done = false;
    function stop(withBounce) {
      if (done) return; done = true; c.destroy(); busy = false;
      document.removeEventListener('visibilitychange', onHide);
      if (window.jQuery) jQuery(document.body).off('afterButtonAnimation.ajaxCart', finishNow);
      if (withBounce) bounce(netIcon());
    }
    function finishNow() { stop(true); }                       // the drawer is about to open: land the catch now
    function onHide() { if (document.hidden) stop(false); }   // tab hidden mid-cast: never leave the photo faded
    document.addEventListener('visibilitychange', onHide);
    if (window.jQuery) jQuery(document.body).one('afterButtonAnimation.ajaxCart', finishNow);
    (function frame(now) {
      if (done) return;
      var t = now - start;
      try { c.draw(Math.min(t, c.end)); } catch (e) { return stop(false); }
      if (t >= c.end) return stop(true);
      requestAnimationFrame(frame);
    })(start);
    setTimeout(function () { stop(false); }, 3500);             // hard stop no matter what
  }

  function hook() {
    if (!window.jQuery) return false;
    var $b = jQuery(document.body);
    $b.on('beforeAddItem.ajaxCart', function () { try { showHeader(); } catch (e) {} });   // net back on screen while the add is in flight
    $b.on('afterAddItem.ajaxCart', function (e, lineItem, form) {
      try { cast(form && form.nodeType ? form : (form && form[0]) || null); } catch (err) { busy = false; }
    });
    return true;
  }
  window.ACCast = { make: make, productImage: productImage };   // used by the preview filmstrip page
  if (!hook()) document.addEventListener('DOMContentLoaded', hook);
})();
